module.exports = __webpack_public_path__ + "img/calendar.24f46025.svg";